export const nullReturnFunc = () => null;
